import { render, staticRenderFns } from "./agentWarrantyView.pug?vue&type=template&id=6c26ead9&lang=pug&"
import script from "./agentWarrantyView.js?vue&type=script&lang=js&"
export * from "./agentWarrantyView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c26ead9')) {
      api.createRecord('6c26ead9', component.options)
    } else {
      api.reload('6c26ead9', component.options)
    }
    module.hot.accept("./agentWarrantyView.pug?vue&type=template&id=6c26ead9&lang=pug&", function () {
      api.rerender('6c26ead9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/views/agentWarrantyView/index.vue"
export default component.exports